module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "AssetProvisioningIcon.8b615f9a.png";